import * as $ from 'jquery';

const settings = {
	totalPrices: '.js-total-price',
	wasPrices: '.js-was-price',
	depositPrices: '.js-deposit-price',
}

export const init = () => {
	$(document).on('updatePrices', (event, data) => {
		updatePrices(settings.totalPrices, data.total);
		if (data.was) {
			updatePrices(settings.wasPrices, data.was);
		}
		if (data.deposit) {
			updatePrices(settings.depositPrices, data.deposit);
		}
	});
}

function updatePrices(selector, price) {
	$(selector).each((index, element) => {
		const $pounds = $(element).children('.pounds');
		if ($pounds.length) {
			const split = price.toString().split('.');
			$pounds.text(split[0]);
			$(element).children('.pence').text('.' + split[1]);
		} else {
			element.innerText = price;
		}
	});
}

init();
